module.exports = __webpack_public_path__ + "img/follow.ffd4f42f.png";